import React, { Fragment } from 'react'; 
import { NavLink } from 'redux-first-router-link'; 
import PropTypes from 'prop-types'; 
import { InView } from 'react-intersection-observer'; 
import { CATEGORY_ROSTER } from '../../consts'; 
import { getFileName } from '../../utils'; 
import { appendImgixParamsLander, TOP_CARD, SMALL_CARD, FEATURED_CARD } from '../../imgixUtils'; 
 
const ArticleCard = ({ data, isMobile, shouldDisplaySponsored }) => { 
  const { 
    url, 
    headline, 
    dek, 
    category, 
    authorName, 
    sponsored, 
    cardClass, 
  } = data; 
  const className = `article-card ${cardClass}`; 
  const imageSrc = appendImgixParamsLander(data, isMobile); 
  const showDetails = category !== CATEGORY_ROSTER; 
  const showDek = (cardClass === TOP_CARD) || (category !== CATEGORY_ROSTER && cardClass === FEATURED_CARD); 
  // this should be updated to only apply to the top card...? 
  const rootMargin = `0% 0% ${isMobile ? '50%' : '25%'} 0%`; 
 
  // check that image flash doesn't keep happening after css updates are applied. 
  return ( 
    <NavLink className={className} to={url}> 
      <InView triggerOnce={true} rootMargin={rootMargin}> 
        {({ inView, ref }) => ( 
          <div ref={ref} className="card-img-container"> 
            {(imageSrc && inView) &&  
              <Fragment> 
                <img className="card-img" src={imageSrc} alt={getFileName(imageSrc)} /> 
                {sponsored === 'Sponsored' &&  shouldDisplaySponsored &&
                  <span className="sponsored-txt">SPONSORED</span> 
                } 
              </Fragment> 
            } 
          </div> 
        )} 
      </InView> 
      <div className="card-wrapper"> 
        <h3 className="card-headline">{headline}</h3> 
        {showDek && 
          <p className="card-dek" dangerouslySetInnerHTML={{ __html: dek }} /> 
        } 
        {showDetails && 
          <div className="card-details"> 
            <h4 className="card-category">{category}</h4> 
            <span className="divider"> &#124;</span> 
            <h5 className="card-author">{authorName}</h5> 
          </div> 
        } 
      </div> 
    </NavLink> 
  ); 
}; 
 
ArticleCard.propTypes = { 
  data: PropTypes.object, 
  className: PropTypes.string, 
  isMobile: PropTypes.bool, 
}; 
 
export default ArticleCard; 
